/**
 * Validates an endpoint is healthy before allowing a
 * user to continue filling in the form.
 * Parent form should have [data-js-salesforce].
 * Button that triggers check should be [data-js-salesforce-check]
 * @returns {[undefined]} []
 */

function saleforceHealthCheck() {
  const STATUS = {
    200: 'ready',
  };

  const forms = document.querySelectorAll('[data-js-salesforce]');

  function handleRequest() {
    if (this.readyState === XMLHttpRequest.DONE) {
      forms.forEach((form) => {
        form.setAttribute('data-js-salesforce', STATUS[this.status] || 'error');
        const errorContainer = form.querySelector('.c-sf-form__error');

        const errorMessage = document.createElement('p');
        errorMessage.innerHTML = this.response;

        if (errorContainer) {
          errorContainer.appendChild(errorMessage);
        }
      });
    }
  }

  function checkBackend(e) {
    if (typeof $ === 'function') {
      // Stop scroll on mutlistep form
      $([document.documentElement, document.body]).stop();
    }

    const button = e.currentTarget;
    const form = button.closest('[data-js-salesforce]');

    if (!form || form.getAttribute('data-js-salesforce') === 'ready') {
      button.removeEventListener('click', checkBackend);
      return;
    }

    form.setAttribute('data-js-salesforce', 'loading');

    form.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });

    const endpoint = `${guidedogsGlobals.gdresturl}salesforce/healthcheck`;
    const httpRequest = new XMLHttpRequest();

    httpRequest.onreadystatechange = handleRequest;

    httpRequest.open('GET', endpoint);
    httpRequest.send();
    button.removeEventListener('click', checkBackend);
  }

  function initialise() {
    forms.forEach((form) => {
      const button = form.querySelector('[data-js-salesforce-check]');
      if (button) button.addEventListener('click', checkBackend);
    });
  }

  if (forms) {
    initialise();
  }
}

export function init() {
  saleforceHealthCheck();
}
